var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompareWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.166,
    height: 14.104,
    viewBox: "0 0 17.166 14.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "compare_white",
    transform: "translate(-3 -8.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8961",
    "data-name": "Path 8961",
    d: "M34.546,10.953H26.515L28.63,9.225a.592.592,0,1,0-.749-.917l-3.4,2.778a.6.6,0,0,0-.071.844c.022.026.047.048.071.072l3.4,2.778a.592.592,0,1,0,.749-.917l-2.115-1.728h8.031a.592.592,0,0,0,0-1.184Z",
    transform: "translate(-14.972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8962",
    "data-name": "Path 8962",
    d: "M13.8,36.7a.594.594,0,0,0-.143-.74l-3.4-2.778a.592.592,0,0,0-.749.917l2.115,1.728H3.592a.592.592,0,1,0,0,1.184h8.031L9.508,38.742a.592.592,0,1,0,.749.917l3.4-2.778A.661.661,0,0,0,13.8,36.7Z",
    transform: "translate(0 -17.515)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareWhite);
export default __webpack_public_path__ + "static/media/compare_white.4092385c7e18ee8779e6e388a226d430.svg";
export { ForwardRef as ReactComponent };